import { MultiBackend, getBackendOptions } from "@minoru/react-dnd-treeview";
import AppErrorBoundary from "AppErrorBoundary";
import { initDatadog } from "datadog";
import React from "react";
import { DndProvider } from "react-dnd";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import "./styles/global.css";

// Initialize Datadog RUM by calling the function from datadog.js
initDatadog();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <Provider store={store}>
        <DndProvider backend={MultiBackend} options={getBackendOptions()}>
          <App />
        </DndProvider>
      </Provider>
    </AppErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
